(() => {
  if (customElements.get('menu-drawer')) {
    return;
  }

  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('[data-toggle-menu]').forEach(el => {
        el.addEventListener('click', this.onOpen.bind(this));
      });

      this.querySelectorAll('[data-button-back]').forEach(el => {
        el.addEventListener('click', this.onBack.bind(this));
      });

      this.querySelectorAll('[data-toggle-dropdown]').forEach(el => {
        el.addEventListener('click', () => {el.classList.toggle('is-active')});
      });
    }

    onOpen(event) {
      event.currentTarget.classList.add('open')
    }

    onBack(event) {
      event.stopPropagation()

      event.currentTarget.closest('[data-toggle-menu]').classList.remove('open')
    }
  }

  customElements.define('menu-drawer', MenuDrawer);
})();
